
import './viewAllApplicationScrutiny.css';
import React, { useState, useEffect } from "react";

import jwt from 'jwt-decode';
import { GET_APPLICATION_LIST,GET_ALL_STAKEHOLDERS} from '../../../common/URLs';
import back from '../../../images/backButton.png';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import {useLocation} from 'react-router-dom';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import apiClient from '../../../axios';


function ViewAllApplicationsScrutiny() {
    const [stakeHolders, setStakeHolders] = useState();
    const [viewApplications, setViewApplications] = useState();
    const [userID, setUserId] = useState();
    useEffect(() => {   
        setUserId(location.state.userid); 
        
    }, []);

    const navigate = useNavigate();
    const location = useLocation();
    const userId = location.state.userid;
    useEffect(() => {
      if (userId) {
        getAllApplications();
      }
    }, [userId]);
    const onView = (urnSelected) => {
        const userData = {
          "urnSelected" : urnSelected,
          "userId": userId
  
        }
          // navigate("/onView",{ state: { data: userData } });
        }
      function getAllApplications() {
        apiClient
          .post(GET_APPLICATION_LIST,
            {
              "userID": userId,
              "status": "Total_Received"
            },
            {
              headers: {
                Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
              }
            }, null
          )
          .then((response) => {
            setViewApplications(response.data);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    const TotalApplicationsArray = viewApplications?.scrutinyWorkFlowStepDetails;
  return (
  <div> <div className="viewall-sidebar-container">
  <ArrowBackIosNew className="arrow-icon" onClick={() => (navigate(-1))} />
  <div className='viewall-div'>
      <div className='viewall_sidebar_header_scrutiny'>Pending Applications</div>
  </div>
  <div className='viewall-text'></div>
</div>
{TotalApplicationsArray?.length>0 ?   <div className="table-wrap-view-scrutiny">
      <table className="table-wrap-view-class">
            <tr className='tr'>
                <th className='th'>S.No</th>
                <th className='th'>Name</th>
                <th className='th'>URN</th>
                <th className='th'>Stakeholder Type</th>
                <th className='th'>Status</th>
                <th className='th'>Action</th>
            </tr>
            {TotalApplicationsArray && TotalApplicationsArray.map((item, index) => {
                                            return (
                                              <tr className='tr' key={index}>
                                              <td className='td'>{index+1}</td> 
                                                <td className='td'>{item?.name}</td>
                                                <td className='td'>{item?.urn}</td>
                                                <td className='td'>{item?.stakeholderType}</td>
                                                <td className='td'>{item?.registrationStatus}</td>                                                     
                                                    <td className='td'><button className='view-btn' onClick={() => onView(item?.urn)}>View</button></td>
                                                </tr>
                                            )
                                        })}
        </table>
    </div> : <div className="table-wrap-view-scrutiny">
      <table className="table-wrap-view-class"><p className='table-no-data'>No data to display</p></table></div> }
    </div>
  );
}
export default ViewAllApplicationsScrutiny;

